import { RetailerApiClient } from '@/services/RetailerApiClient'

export default {
  createNotificationDevice(notificationDevice) {
    return RetailerApiClient.post('notification-devices', notificationDevice)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
